module.exports = __webpack_public_path__ + "media/images/ghetto_pin-1eabb2fb.svg";